import React from "react"

import Icon, { IconProps } from "./Icon"

const ExternalIcon = (props: IconProps) => (
  <Icon stroke="none" strokeWidth={1} {...props}>
    <path
      vectorEffect="non-scaling-stroke"
      d="M12 12l5-5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      stroke="currentColor"
    />
    <path
      vectorEffect="non-scaling-stroke"
      d="M13.363 7H17v3.636"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
    <path
      vectorEffect="non-scaling-stroke"
      d="M10.636 8.818H7V17h8.182v-3.637"
      strokeMiterlimit="10"
      strokeLinecap="round"
      stroke="currentColor"
    />
  </Icon>
)

export default ExternalIcon
